import { Tabs } from "antd";
import React from "react";
import Category from "../pages/Footer/Category";
import Link from "../pages/Footer/Link";

const Footer = (props) => {
  const { TabPane } = Tabs;

  const onChange = (key) => {
    console.log(key);
  };

  return (
    <Tabs defaultActiveKey="1" onChange={onChange}>
      <TabPane tab="Chuyên mục" key="1">
        <Category />
      </TabPane>
      <TabPane tab="Liên kết chuyên mục" key="2">
      <Link />
      </TabPane>

    </Tabs>
  );
};

export default Footer;
